import { Component, isDevMode, VERSION } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'claro-box';

  constructor() {
    console.warn(`[OnlyTV] Version: ${environment.version}/${VERSION.full}, Dev? ${isDevMode()}`);
  }
}
